import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/footballCard.css';
// helpers
import {getText} from '../../../../../helpers/localization';
import ImageLoader from 'react-load-image';
import {ASSETS_URL} from '../../../../../constants/endpoints';
import {getGameFromChannel} from "../../../helpers/gameHelpers";
import {isSoccer3FootballEvent} from '../../../../../helpers/moduleHelpers';

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events
    };
};

class SelectedFootballCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events
        };
    }

    findKit(kitId, length) {
        let id = '' + kitId;
        while (id.length < length) {
            id = '0' + id;
        }
        return id;
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let categoryOrder = storeData.vpp.games[storeData.vpp.selectedGameIndex].categoryOrder;
        let games = [];
        let showActive = this.props.showActive;
        let activeEvent = storeData.vpp.events[0];

        storeData.vpp.games.map((game, index) => {
            if (categoryOrder === game.categoryOrder) {
                games.push(game);
            }
        });

        let homeTeamKit;
        let awayTeamKit;
        let homeTeamImageSrc;
        let awayTeamImageSrc;
        let footballIconStyle;
        let currentEvent = showActive == true ? activeEvent : selectedEvent;

        if (isSoccer3FootballEvent(currentEvent.eventType)) {
            homeTeamKit = 'Small/Full/Team_' + this.findKit(currentEvent.homeKitId, 4);
            awayTeamKit = 'Small/Full/Team_' + this.findKit(currentEvent.awayKitId, 4);
            homeTeamImageSrc = `${ASSETS_URL}soccer3/silks/${homeTeamKit}.png`;
            awayTeamImageSrc = `${ASSETS_URL}soccer3/silks/${awayTeamKit}.png`;
            footballIconStyle = style.soccer3FootballIcon;
        } else {
            homeTeamKit = 'bannerIcon/' + currentEvent.teamOne.split(' ').join('') + '_Home';
            awayTeamKit = 'bannerIcon/' + currentEvent.teamTwo.split(' ').join('') + '_' + (currentEvent.awayTeamKit.toString() === '0' ? 'Home' : 'Away');
            homeTeamImageSrc = `${ASSETS_URL}${getGameFromChannel(currentEvent.channel, storeData.vpp.games).assetsPath}/silks/${homeTeamKit}.png`;
            awayTeamImageSrc = `${ASSETS_URL}${getGameFromChannel(currentEvent.channel, storeData.vpp.games).assetsPath}/silks/${awayTeamKit}.png`;
            footballIconStyle = style.footballIcon;
        }

        let showTeamName = showActive == true ? `${style.gameTitle} ${style.gameTitleBannerMobile}` : style.gameTitle;
        let titleBanner = showActive == true ? style.gameTitleBannerTop : style.gameTitleBannerBottom;
        // let gameSubTab = (
        //     <div className={`${style.gameTab}`}>
        //         <GameTab games={games} store={this.props.store}></GameTab>
        //     </div>
        // );

        return (
            <div id={'football_card'} className={`${titleBanner}`}>
                <div className={style.teamNameImage}>
                    <div className={style.imageLoader}>
                        <ImageLoader
                            src={`${homeTeamImageSrc}`}>
                            <img
                                src={`${homeTeamImageSrc}`}
                                className={`${footballIconStyle}`}
                                alt={`icon_${currentEvent.teamOne}`}/>
                            <div>{''}</div>
                            <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={`${footballIconStyle}`}
                                 alt={`loading`}/>
                        </ImageLoader>
                    </div>
                    <div className={`${showTeamName}`}>{`${getText(currentEvent.teamOne, this.props.store)}`}</div>
                </div>
                <div className={style.versus}>{getText('VS', this.props.store)}</div>
                <div className={style.teamNameImage}>
                    <div className={`${showTeamName}`}>{`${getText(currentEvent.teamTwo, this.props.store)}`}</div>
                    <div className={style.imageLoader}>
                        <ImageLoader
                            src={`${awayTeamImageSrc}`}>
                            <img
                                src={`${awayTeamImageSrc}`}
                                className={`${footballIconStyle}`}
                                alt={`icon_${currentEvent.teamTwo}`}/>
                            <div>{''}</div>
                            <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={`${footballIconStyle}`}
                                 alt={`loading`}/>
                        </ImageLoader>
                    </div>

                </div>
            </div>


        );
    }
}

export default connect(mapStateToProps)(SelectedFootballCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/containers/selectedFootballCard.js